// extracted by mini-css-extract-plugin
export default {"label":"label-module--label--f1afc","icon":"label-module--icon--07e0f"};